import { useQuery } from "@tanstack/react-query";
import { getBlogCategories } from "../../api/apiBlogCategories";
import i18next from "i18next";

/**
 * Hook لجلب قائمة التصنيفات المفلترة
 * @param {Object} params - Query parameters (page, per_page, search, trashed)
 */
export function useGetBlogCategories(params = {}) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["blog-categories", params, i18next.language],
        queryFn: () => getBlogCategories(params),
        retry: false,
    });

    const categories = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params.per_page || 15, total: 0 };

    return { isLoading, error, categories, meta, refetch };
}
